import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { XIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, Switch, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import ActionsMenu from './ActionsMenu/ActionsMenu'
import { actionTypes, dateStates } from './constants'
import { getDateChipStyles } from './helpers'
import { getDateChipInfo } from './helpers'
import * as Styles from './styles'

const PolicyRuleItem = ({ rule, index, onChangeEnabled, onEdit, onDuplicate, onDelete, disabled }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const { info } = useContext(AppContext)

  const actionConfig = actionTypes[rule.action]
  const dateChipInfo = getDateChipInfo({
    startsAt: rule.valid_from,
    endsAt: rule.valid_until,
    t,
    language: i18n.language,
    timeZone: info.selectedStore.timezone,
  })

  const isExpired = dateChipInfo?.state === dateStates.expired
  const mutedTextColor = isExpired ? theme.colors.text.subtle : theme.colors.text.default

  return (
    <Styles.MainContainer index={index}>
      <Styles.PositionContainer>
        <Text type="bodyMBold">#{rule.internal_id}</Text>
      </Styles.PositionContainer>
      <Styles.ContentContainer>
        <Styles.Header>
          <Styles.HeaderLeft>
            <Tooltip
              disabled={!isExpired}
              title={t('Para reactivar esta regla, extiende o cambia su periodo de validez.')}
            >
              <Switch
                checked={isExpired ? false : rule.is_enabled}
                onChange={e => onChangeEnabled(rule, e.target.checked)}
                label={
                  <Text type="bodyMBold" color={mutedTextColor}>
                    {rule.name}
                  </Text>
                }
                disabled={disabled || isExpired}
              />
            </Tooltip>
            {isExpired && (
              <Chip
                label={t('Expirada')}
                Icon={XIcon}
                backgroundColor={theme.colors.disabled.surface}
                color={theme.colors.text.inverse}
              />
            )}
          </Styles.HeaderLeft>
          {!disabled && <ActionsMenu rule={rule} onEdit={onEdit} onDuplicate={onDuplicate} onDelete={onDelete} />}
        </Styles.Header>
        {(actionConfig || dateChipInfo) && (
          <Styles.ChipsContainer>
            {actionConfig && (
              <Chip
                label={t(actionConfig.labelKey)}
                Icon={actionConfig.icon}
                backgroundColor={theme.colors.info.surface}
                color={theme.colors.info.onSurface}
                disabled={isExpired}
              />
            )}
            {dateChipInfo && (
              <Chip
                label={dateChipInfo.label}
                Icon={getDateChipStyles(theme)[dateChipInfo.state].icon}
                backgroundColor={getDateChipStyles(theme)[dateChipInfo.state].backgroundColor}
                color={getDateChipStyles(theme)[dateChipInfo.state].color}
                disabled={isExpired}
              />
            )}
          </Styles.ChipsContainer>
        )}
        {rule.notes && (
          <Styles.Description>
            <Text type="bodyMRegular" color={mutedTextColor}>
              {rule.notes}
            </Text>
          </Styles.Description>
        )}
      </Styles.ContentContainer>
    </Styles.MainContainer>
  )
}

export default PolicyRuleItem
